import Reveal from "./Reveal";

const DOUBTS = [
    { q: "Candlestick ni sebenarnya tunjukkan apa?", tone: "text-lav", blob: "bg-electric/15", tag: "PERSOALAN 01" },
    { q: "Bila masa yang sesuai untuk mula belajar entry?", tone: "text-neon", blob: "bg-neon/15", tag: "PERSOALAN 02" },
    { q: "Macam mana nak faham arah trend dengan betul?", tone: "text-chrome", blob: "bg-white/10", tag: "PERSOALAN 03" },
];

const Problem = () => (
    <section data-testid="problem-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute right-0 top-40 h-[400px] w-[400px] rounded-full bg-neon/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                    Realiti beginner
                </p>
                <h2 className="mt-5 max-w-4xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl md:text-6xl">
                    BARU NAK BELAJAR TRADING?{" "}
                    <span className="text-duo-grad">RASA PENING</span> DENGAN
                    SEMUA ISTILAH NI?
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <p className="mt-8 max-w-2xl leading-relaxed text-white/70">
                    Itu normal, semua orang start dari zero. Tapi bila buka
                    chart, mesti ada banyak persoalan dalam kepala.
                </p>
            </Reveal>

            <div className="mt-12 flex flex-col gap-4 md:flex-row md:gap-6">
                {DOUBTS.map((d, i) => (
                    <Reveal key={d.tag} delay={0.12 * i} className="flex-1">
                        <div
                            data-testid={`problem-card-${i + 1}`}
                            className="card-luxe group relative h-full overflow-hidden rounded-3xl p-6 transition duration-300 hover:-translate-y-1 hover:border-white/20 md:p-7"
                        >
                            <div
                                className={`pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full ${d.blob} blur-2xl`}
                            />
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                                {d.tag}
                            </p>
                            <p
                                className={`mt-4 font-display text-lg font-bold leading-snug md:text-xl ${d.tone}`}
                            >
                                “{d.q}”
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-14 max-w-3xl space-y-5 leading-relaxed text-white/70">
                    <p>
                        Sebenarnya, semua bermula dengan kefahaman asas yang
                        betul.
                    </p>
                    <p className="border-l-2 border-neon pl-6 font-medium text-white">
                        Sebab tu dalam Engulfing Newbie Onboard Webinar ni, kita
                        mula dari asas candlestick dan teknik Engulfing —
                        step-by-step, bersama Queen of Dollars.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Problem;
